import routesAccount from './routes-account'
import routesSeguranca from './routes-seguranca'
import Permissoes from '@/utils/permissoes'
import routesCadastros from './routes-cadastros'
import routerParametros from './router-parametros'
import routerLocacoes from './router-locacoes'
import routerRoteirizacao from './router-roteirizacao'
import routerOperacao from './router-operacao'

const routes = [
  // Dashboards
  {
    path: "/",
    name: "home",
    meta: { 
      title: "Home", 
      authRequired: true,
      permissoes: [Permissoes.AllLoggedUsers] 
    },
    component: () => import("@/views/home/index.vue")
  },
  {
    path: "/meu-perfil",
    name: "meu-perfil",
    meta: { 
      title: "Editar meu perfil", 
      authRequired: true,
      permissoes: [Permissoes.AllLoggedUsers]
    },
    component: () => import("@/views/editar-perfil/index.vue") ,
  }
];

export default [
  ...routes, ...routesAccount, ...routesSeguranca, ...routesCadastros, ...routerParametros, ...routerLocacoes,...routerRoteirizacao, ...routerOperacao
];
